import React from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { addExample } from '../../actioncreators/actioncreators'
const { Component } = React

const Button = styled.button`
  background: #ffffff00;
  border: none;
`

const I = styled.i`
-webkit-transition: -webkit-transform .1s ease-in-out;
transition: transform .1s ease-in-out;
color: #14B300;

&:hover {
  -webkit-transform: rotate(90deg);
  transform: rotate(90deg);
}
`

class AddExample extends Component {
  render () {
    return (
      <Button onClick={this.props.addExample}>
        <I className='fas fa-plus fa-2x' title='Add example' />
      </Button>
    )
  }
}

const mapDispatchToProps = function (dispatch, ownProps) {
  return {
    addExample: function (event) {
      dispatch(addExample(ownProps.rule))
    }
  }
}

export default connect(null, mapDispatchToProps)(AddExample)
